/** Decoration span marker class. */
export const MEDICATION_HIGHLIGHTS_CLASS = 'medication-highlights';

export const DATA_MED_INDEX = 'data-med-index';

export const MEDICATION_HIGHLIGHTS_CLASSES = [
  MEDICATION_HIGHLIGHTS_CLASS,
  'cursor-pointer rounded-xs',
  'bg-entity-blue-muted text-entity-blue-foreground',
  'ring-1 ring-inset ring-entity-blue-foreground/15',
  'hover:bg-entity-blue-muted/80',
  'motion-safe:transition-colors motion-safe:duration-150',
].join(' ');
